<script src="../../main.js"></script>
<template>
    <div id="myDateShow">
        <div class="title">{{skuInfo.id?'修改':'新增'}} 商品</div>
        <div id="dataShow">
            <div class="line">
                <div class="key">商品分类</div>
                <div class="value">
                    <el-select class="w500" v-model="skuInfo.skuClassifyId" placeholder="请选择商品类型">
                        <el-option
                                v-for="item in skuClassify"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="line">
                <div class="key">活动商品类型</div>
                <div class="value">
                    <el-select class="w500" v-model="skuInfo.activityClassify" placeholder="请选择商品类型">
                        <el-option
                                v-for="item in activityClassify"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="line" v-if="skuInfo.activityClassify=='秒购商品'">
                <div class="key">秒购开始时间</div>
                <div class="value">
                    <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="skuInfo.seckillStartDate"
                            type="datetime"
                            placeholder="请填写商品秒购开始时间">
                    </el-date-picker>
                </div>
            </div>
            <div class="line" v-if="skuInfo.activityClassify=='秒购商品'">
                <div class="key">秒购结束时间</div>
                <div class="value">
                    <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="skuInfo.seckillEndDate"
                            type="datetime"
                            placeholder="请填写商品秒购结束时间">
                    </el-date-picker>
                </div>
            </div>
            <div class="line">
                <div class="key">特殊商品类型</div>
                <div class="value">
                    <el-select class="w500" v-model="skuInfo.specialClassify" placeholder="请选择商品类型">
                        <el-option
                                v-for="item in specialClassify"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="line" v-if="skuInfo.specialClassify=='坞栈商品'">
                <div class="key">坞栈市区信息</div>
                <div class="value">
                    <select-input
                            @inputFocus="getCoveShedCity"
                            @handleSelect="handleSelectCoveShedCity"
                            :itemArr="cityArr"
                            :value="skuInfo.coveShedCity"
                            :placeholder="'请填写坞栈市区信息'">
                    </select-input>
                </div>
            </div>
            <div class="line" v-if="skuInfo.coveShedCity">
                <div class="key">坞栈社区</div>
                <div class="value">
                    <select-input
                            @inputFocus="getCoveShedCityTwo"
                            @handleSelect="handleSelectCoveShedCityTwo"
                            :itemArr="cityArrTwo"
                            :value="skuInfo.coveShedCityTwo"
                            :placeholder="'请填写坞栈名称'">
                    </select-input>
                </div>
            </div>
            <div class="line" v-if="skuInfo.coveShedCityTwo">
                <div class="key">坞栈名称</div>
                <div class="value">
                    <select-input
                            @inputFocus="getCoveShedName"
                            @handleSelect="handleSelectCoveShedName"
                            :itemArr="coveShedNames"
                            :value="skuInfo.coveShedName"
                            :placeholder="'请填写坞栈名称'">
                    </select-input>
                </div>
            </div>
            <div class="line">
                <div class="key">商品名称</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuName" maxlength="30" show-word-limit
                              placeholder="请填写商品名称"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">商品副标题</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuTitle" maxlength="30" show-word-limit
                              placeholder="请填写商品副标题"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">商品描述</div>
                <div class="value">
                    <el-input type="textarea" autosize class="w500" v-model="skuInfo.skuDetail"
                              placeholder="请填写商品描述的内容"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">参与分佣</div>
                <div class="value">
                    <el-switch @change="changeDivideCommission()" v-model="skuInfo.isDivideCommission" active-value="Y"
                               inactive-value="N"></el-switch>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">商品二级类型</div>
                <div class="value">
                    <el-select class="w500" v-model="skuInfo.secondaryType" placeholder="请选择二级商品类型">
                        <el-option
                                v-for="item in secondaryTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">引荐人信息</div>
                <div class="value">

                    <div>引荐人姓名:{{skuInfo.merchants.referencePayeeName}}</div>
                    <div>引荐人手机:{{skuInfo.merchants.referencePayeeMobile}}</div>
                    <div>引荐人联系地址:{{skuInfo.merchants.referenceContactAddress}}</div>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">引荐佣金</div>
                <div class="value">
                    <el-input class="w500" type="number" @input="limitationCommission()" v-model="skuInfo.recommendCommissionProportion"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">产出上线时间</div>
                <el-date-picker v-model="skuInfo.outPutUpTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                                format="yyyy 年 MM 月 dd 日">
                </el-date-picker>
            </div>
            <div class="line">
                <div class="key">所属农基商</div>
                <div class="value">
                    <select-input
                            @inputFocus="getMerchantNameArr"
                            @handleSelect="handleSelectMerchants"
                            :itemArr="merchantNames"
                            :value="skuInfo.merchantsName"
                            :placeholder="'请填写所属农基商'">
                    </select-input>
                </div>
            </div>
            <div class="line">
                <div class="key">出产地</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuProducers" placeholder="请填写商品出产地"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">生产日期</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuProductionDate" placeholder="请填写商品生产日期"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">规格</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuWeight" placeholder="请填写商品的重量单位，g、kg、只或者其他"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">售价</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuPrice"
                              placeholder="请填写商品的价格（请输入数字，如10、10.5，禁止输入'10元'）"></el-input>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">商品成本价（拿货价）</div>
                <div class="value">
                    <el-input class="w500" @input="profitCount()" type="number" v-model.number="skuInfo.materialCost"
                              placeholder="请填写商品成本价格（请输入数字，如10、10.5，禁止输入'10元'）"></el-input>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">运营成本</div>
                <div class="value">
                    <el-input class="w500" @input="profitCount()" type="number" v-model.number="skuInfo.operateCost"
                              placeholder="请填写运营成本价格（请输入数字，如10、10.5，禁止输入'10元'）"></el-input>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">包材成本</div>
                <div class="value">
                    <el-input class="w500" @input="profitCount()" type="number"
                              v-model.number="skuInfo.packagingMaterialsCost"
                              placeholder="请填写包材成本价格（请输入数字，如10、10.5，禁止输入'10元'）"></el-input>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">其他成本</div>
                <div class="value">
                    <el-input class="w500" @input="profitCount()" type="number" v-model.number="skuInfo.otherCost"
                              placeholder="请填写其他成本价格（请输入数字，如10、10.5，禁止输入'10元'）"></el-input>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">共计成本</div>
                <div class="value">
                    <el-input class="w500" type="number" v-model="skuInfo.totalCost" :disabled="true"></el-input>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">商品利润</div>
                <div class="value">
                    <el-input class="w500" type="number" v-model="skuInfo.commodityProfit" :disabled="true"></el-input>
                </div>
            </div>
            <div class="line" v-if="showDivideCommissionInformation">
                <div class="key">利润比例</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.profitRatio" :disabled="true"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">多规格</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuManyWeight"
                              placeholder="请填写商品的重量单位，g、kg、只或者其他"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">多规格售价</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuManyPrice"
                              placeholder="请填写商品的价格（请输入数字，如10、10.5，禁止输入'10元'）"></el-input>
                </div>
            </div>
            <div class="line" v-if="skuInfo.activityClassify=='秒购商品'">
                <div class="key">商品秒购价</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.seckillPrice" maxlength="30" show-word-limit
                              placeholder="请填写商品秒购价"></el-input>
                </div>
            </div>
            <div class="line" v-if="skuInfo.activityClassify=='秒购商品'">
                <div class="key">商品多规格秒购价</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.seckillManyPrice" maxlength="30" show-word-limit
                              placeholder="请填写商品秒购价"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">库存</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuInventory" placeholder="请填写商品的库存"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">商品标签</div>
                <div class="value">
                    <div class="tag" v-for="(item,index) in skuInfo.labelValues">
                        <span>{{item.labelName}}</span>
                        <i class="el-icon-circle-close" @click="delLabel(index)"></i>
                    </div>
                    <select-input
                            @inputFocus="getLabelValues"
                            @handleSelect="handleSelectLabel"
                            :itemArr="labels"
                            :value="label"
                            :placeholder="'请输入商品标签'">
                    </select-input>
                </div>
            </div>
            <div class="line">
                <div class="key">商品存放建议</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.storeAdvice" placeholder="填写商品存放建议"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">商品包邮说明</div>
                <div class="value">
                    <el-button type="primary" @click="addPostage">添加补邮费信息</el-button>
                </div>
            </div>
            <div class="line" v-for="item in skuInfo.postageList">
                <div class="key"></div>
                <div class="value">
                    <el-input style="width: 100px;" v-model="item.postageKey" placeholder="补邮费标题"></el-input>
                    <el-input type="textarea" :autosize="{ minRows: 4 }" style="width: 300px;"
                              v-model="item.postageValue" placeholder="补邮费区域"></el-input>
                    <el-input style="width: 100px;" v-model="item.postagePrice" placeholder="补邮费金额"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">商品属性补充</div>
                <div class="value">
                    <el-input class="w500" v-model="skuInfo.skuNote" placeholder="记录商品的额外信息"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">是否立即上架</div>
                <div class="value">
                    <el-select class="w500" v-model="skuInfo.isShelves" placeholder="请选择">
                        <el-option key="0" label="上架" value="0"></el-option>
                        <el-option key="1" label="不上架" value="1"></el-option>
                        <el-option key="2" label="封仓" value="2"></el-option>
                        <el-option key="3" label="待开售" value="3"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="line">
                <div class="key">附加服务</div>
                <div class="value">
                    <el-checkbox-group v-model="skuInfo.pmsExtras">
                        <el-checkbox :label="item" v-for="item in pmsExtras">{{item.extraService}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div class="line">
                <div class="key">商品主图</div>
                <div class="value">
                    <img class="skuImg" v-show="skuInfo.skuDefaultImgUrl" :src="skuInfo.skuDefaultImgUrl" alt="">
                    <div class="upload">
                        <el-upload
                                :headers="headers"
                                ref="defaultUpload"
                                :on-progress="progress"
                                :on-change="defaultUpload"
                                :on-success="defaultSuccess"
                                class="upload-demo"
                                name="multipartFile"
                                :action="baseURL+'/skuInfo/uploadDefaultImg'"
                                :auto-upload="false"
                                :show-file-list="false"
                                list-type="picture-card">
                            <i class="el-icon-plus"></i>
                            <div class="el-upload__tip" slot="tip">上传新的主图，图片长宽为3：4，文件格式为通用jpg/png，数量：1</div>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div class="line">
                <div class="key">商品轮播图</div>
                <div class="value">
                    <img class="swiperImg" v-show="skuInfo.swiperImg" :src="skuInfo.swiperImg" alt="">
                    <div class="upload">
                        <el-upload
                                :headers="headers"
                                ref="swiperUpload"
                                :on-progress="progress"
                                :on-change="swiperUpload"
                                :on-success="swiperSuccess"
                                class="upload-demo"
                                name="multipartFile"
                                :action="baseURL+'/skuInfo/uploadSwiperImgs'"
                                :auto-upload="false"
                                list-type="picture-card"
                                :show-file-list="false">
                            <i class="el-icon-plus"></i>
                            <div class="el-upload__tip" slot="tip">轮播海报的图片，长宽为750：300，文件格式为通用jpg/png，数量：1</div>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div class="line">
                <div class="key">商品详情图</div>
                <div class="value">
                    <div>
                        <div class="skuImgDiv" v-for="(item,index) in skuInfo.detailImgs"
                             @mouseover="detailImgs_mouseover(index)" @mouseout="detailImgs_mouseout(index)">
                            <img class="skuImg" :src="item.imgUrl" alt="">
                            <div style="width: 100%;height: 100%; position: absolute;z-index: 1;top: 0"
                                 :style="isImgActiveArr[index]?'background-color: rgba(0,0,0,.5);':''"></div>
                            <img v-if="isImgActiveArr[index]" @click="delDetailImgs(index)" class="deleteIcon"
                                 src="../../assets/img/delete.svg" alt="">
                        </div>
                    </div>
                    <div class="upload">
                        <el-upload
                                :headers="headers"
                                ref="upload"
                                multiple
                                class="upload-demo"
                                :on-progress="progress"
                                :on-change="fileChange"
                                :on-remove="handleRemove"
                                :on-exceed="handleExceed"
                                :auto-upload="false"
                                name="multipartFiles"
                                :action="baseURL+'/skuInfo/uploadImgs'"
                                :http-request="uploadFile"
                                :limit="limit"
                                accept=".jpg,.png"
                                :file-list="fileList">
                            <el-button slot="trigger" size="small" type="primary" style="margin-top: 20px">选取文件
                            </el-button>
                            <el-button style="margin-left:10px;margin-top: 20px" size="small" type="success"
                                       @click="submitUpload">上传详情图片到服务器
                            </el-button>
                            <div class="el-upload__tip" slot="tip">商品详情图，长宽为375：667，文件格式为通用jpg/png，最大数量：10</div>
                        </el-upload>

                    </div>
                </div>
            </div>
            <div class="line">
                <div class="key">图示详情</div>
                <div class="value">
                    <div>
                        <div class="skuImgDiv" v-for="(item,index) in skuInfo.detailImgs"
                             @mouseover="detailImgs_mouseover(index)" @mouseout="detailImgs_mouseout(index)">
                            <img class="skuImg" :src="item.imgUrl" alt="">
                            <div style="width: 100%;height: 100%; position: absolute;z-index: 1;top: 0"
                                 :style="graphicalDetailsArr[index]?'background-color: rgba(0,0,0,.5);':''"></div>
                            <img v-if="graphicalDetailsArr[index]" @click="delDetailImgs(index)" class="deleteIcon"
                                 src="../../assets/img/delete.svg" alt="">
                        </div>
                    </div>
                    <div class="upload">
                        <el-upload
                                ref="SkuInfoGraphicalDetails"
                                class="upload-demo"
                                multiple
                                name="multipartFile"
                                :on-remove="removeTraceabilityFiles"
                                :before-remove="beforeRemoveTraceabilityFiles"
                                :on-exceed="traceabilityFilesExceed"
                                :on-success="traceabilityFilesSuccess"
                                :data="uploadParam.SkuInfoGraphicalDetails"
                                :action="baseURL+'/system/uploadFiles'"
                                :limit="10"
                                :file-list="skuInfoGraphicalDetailsFiles"
                                list-type="picture-card"
                                accept=".jpg,.png">
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">图示详情，长宽为375：667，文件格式为通用jpg/png，最大数量：10</div>
                        </el-upload>

                    </div>
                </div>
            </div>
            <div class="line">
                <div class="key"></div>
                <div class="value">

                </div>
            </div>

            <!--  -->
            <el-dialog title="审核" :visible.sync="showTraceability" width="60%">
                <el-steps :active="stepIndex" finish-status="success">
                    <el-step></el-step>
                    <el-step></el-step>
                    <el-step></el-step>
                </el-steps>
                <div style="margin-bottom: 40px;margin-top: 20px;">
                    <div style="font-size: 16px;font-weight:bold;">溯源码信息</div>
                    <div class="dataShow">
                        <div v-if="stepIndex==1">
                            <div class="line">
                                <div class="key" style="font-weight:bold;">种植主体</div>
                            </div>
                            <div class="line">
                                <div class="key">农基编号</div>
                                <div class="value">
                                    <el-input class="w500" v-model="skuInfo.merchants.code" :disabled="true"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">农基商名称</div>
                                <div class="value">
                                    <el-input class="w500" v-model="skuInfo.merchants.merchantsName" :disabled="true"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">农基区域</div>
                                <div class="value">
                                    <el-input class="w500" v-model="skuInfo.merchants.detailAddress" :disabled="true"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">农基面积</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.agriculturalArea"
                                              placeholder="请填写农基面积"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">经度</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.longitude"
                                              placeholder="请填写经度"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">维度</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.dimension"
                                              placeholder="请填写维度"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">社会信用统一代码</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.unifiedSocialCreditCode"
                                              placeholder="请填写维度"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">营业执照</div>
                                <div class="value">
                                    <el-upload
                                            ref="TraceabilityBusinessLicense"
                                            class="upload-demo"
                                            multiple
                                            name="multipartFile"
                                            :on-remove="removeTraceabilityFiles"
                                            :before-remove="beforeRemoveTraceabilityFiles"
                                            :on-exceed="traceabilityFilesExceed"
                                            :on-success="traceabilityFilesSuccess"
                                            :data="uploadParam.TraceabilityBusinessLicense"
                                            :action="baseURL+'/system/uploadFiles'"
                                            :limit="10"
                                            :file-list="traceabilityBusinessLicenseFiles"
                                            list-type="picture-card"
                                            accept=".jpg,.png">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">营业执照图片，文件格式为通用jpg/png，数量：1 以上</div>
                                    </el-upload>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key" style="font-weight:bold;">播种移栽</div>
                            </div>
                            <div class="line">
                                <div class="key">种子名称</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.seedName"
                                              placeholder="请填写种子名称"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">种植面积</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.plantingArea"
                                              placeholder="请填写种植面积"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">种植时间</div>
                                <div class="value">
                                    <el-date-picker v-model="traceability.plantingTime" type="date"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="选择种植时间"></el-date-picker>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">种植数量</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.plantingQuantity"
                                              placeholder="请填写种植数量"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">种植方式</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.plantingPatterns"
                                              placeholder="请填写种植方式"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key" style="font-weight:bold;">施肥管理</div>
                            </div>
                            <div class="line">
                                <div class="key">施肥时间</div>
                                <div class="value">
                                    <el-date-picker v-model="traceability.fertilizationTime" type="date"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="选择施肥时间"></el-date-picker>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">施肥名称</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.fertilizationName"
                                              placeholder="请填写种子名称"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">施肥类型</div>
                                <div class="value">
                                    <el-select v-model="traceability.fertilizerType" placeholder="请选择施肥类型">
                                        <el-option
                                                v-for="item in fertilizerType"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">每亩用量</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.usagePerMu"
                                              placeholder="请填写每亩用量"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">施肥方式</div>
                                <div class="value">
                                    <el-select v-model="traceability.fertilizationType" placeholder="请选择施肥方式">
                                        <el-option
                                                v-for="item in fertilizationType"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key" style="font-weight:bold;">病虫害防治</div>
                            </div>
                            <div class="line">
                                <div class="key">病害名称</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.diseaseName"
                                              placeholder="请填写病害名称"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">药剂名称</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.drugName"
                                              placeholder="请填写药剂名称"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">防治时间</div>
                                <div class="value">
                                    <el-date-picker v-model="traceability.administerTime" type="date"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="选择防治时间"></el-date-picker>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">防治类型</div>
                                <div class="value">
                                    <el-select v-model="traceability.administerType" placeholder="请选择施肥方式">
                                        <el-option
                                                v-for="item in administerType"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">防治机构</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.administerInstitution"
                                              placeholder="请填写防治机构"></el-input>
                                </div>
                            </div>
                        </div>
                        <div v-if="stepIndex==2">
                            <div class="line">
                                <div class="key" style="font-weight:bold;">采收管理</div>
                            </div>
                            <div class="line">
                                <div class="key">采收负责人</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.recoveryHeadName"
                                              placeholder="请填写采收负责人"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">采收人数</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.recoveryPeopleNumber"
                                              placeholder="请填写采收人数"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">采收类型</div>
                                <div class="value">
                                    <el-select v-model="traceability.recoveryType" placeholder="请选择采收类型">
                                        <el-option
                                                v-for="item in recoveryType"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">采收时间</div>
                                <div class="value">
                                    <el-date-picker v-model="traceability.recoveryTime" type="date"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="选择采收时间"></el-date-picker>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">甜度范围数值</div>
                                <div class="block">
                                    <el-slider input-size="small" v-model="sweetnessRange" range="true" show-stops :max="100"></el-slider>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">测糖仪凭证</div>
                                <div class="value">
                                    <el-upload
                                            ref="TraceabilitySugarMeasurementVoucher"
                                            class="upload-demo"
                                            multiple
                                            name="multipartFile"
                                            :on-remove="removeTraceabilityFiles"
                                            :before-remove="beforeRemoveTraceabilityFiles"
                                            :on-exceed="traceabilityFilesExceed"
                                            :on-success="traceabilityFilesSuccess"
                                            :data="uploadParam.TraceabilitySugarMeasurementVoucher"
                                            :action="baseURL+'/system/uploadFiles'"
                                            :limit="10"
                                            list-type="picture-card"
                                            :file-list="traceabilitySugarMeasurementVoucherFiles"
                                            accept=".jpg,.png">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">
                                            测糖仪凭证图片，尺寸为750（宽度）：不限（高度），文件格式为通用jpg/png，数量：1 以上
                                        </div>
                                    </el-upload>
                                </div>
                            </div>

                            <div class="line">
                                <div class="key" style="font-weight:bold;">产出初级品</div>
                            </div>
                            <div class="line">
                                <div class="key">产出物名称</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.outPutName"
                                              placeholder="请填写产出物名称"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">产出物数量</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.outPutNum"
                                              placeholder="请填写产出物数量"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">产出单位</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.outPutUnit"
                                              placeholder="请填写产出单位"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key" style="font-weight:bold;">产品加工</div>
                            </div>
                            <div class="line">
                                <div class="key">加工企业</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.processingEnterprises"
                                              placeholder="请填写加工企业"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">加工方式</div>
                                <div class="value">
                                    <el-select v-model="traceability.processingType" placeholder="请选择加工方式">
                                        <el-option
                                                v-for="item in processingType"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">生产许可证号</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.productionLicenseNumber"
                                              placeholder="请填写生产许可证号"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">执行标准</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.executiveStandards"
                                              placeholder="请填写执行标准"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">包装方式</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.packagingType"
                                              placeholder="请填写包装方式"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key" style="font-weight:bold;">质量检验</div>
                            </div>
                            <div class="line">
                                <div class="key">质检机构</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.qualityInspectionInstitution"
                                              placeholder="请填写质检机构"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">质检机构地址</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.qualityInspectionInstitutionAddress"
                                              placeholder="请填写质检机构地址"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">质检方式</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.qualityInspectionType"
                                              placeholder="请填写质检方式"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">质检类项</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.qualityInspectionItems"
                                              placeholder="请填写质检类项"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">质检时间</div>
                                <div class="value">
                                    <el-date-picker v-model="traceability.qualityInspectionTime" type="date"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="选择质检时间"></el-date-picker>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">质检报告</div>
                                <div class="value">
                                    <el-upload
                                            ref="TraceabilityQualityInspectionReport"
                                            class="upload-demo"
                                            multiple
                                            name="multipartFile"
                                            :on-remove="removeTraceabilityFiles"
                                            :before-remove="beforeRemoveTraceabilityFiles"
                                            :on-exceed="traceabilityFilesExceed"
                                            :on-success="traceabilityFilesSuccess"
                                            :data="uploadParam.TraceabilityQualityInspectionReport"
                                            :action="baseURL+'/system/uploadFiles'"
                                            :limit="10"
                                            list-type="picture-card"
                                            :file-list="traceabilityQualityInspectionReportFiles"
                                            accept=".jpg,.png">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">
                                            商品质检报告图片，尺寸为750（宽度）：不限（高度），文件格式为通用jpg/png，数量：1 以上
                                        </div>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                        <div v-if="stepIndex==3">
                            <div class="line">
                                <div class="key" style="font-weight:bold;">地理标志产品</div>
                            </div>
                            <div class="line">
                                <div class="key">是否地理标志产品</div>
                                <div class="value">
                                    <el-switch v-model="traceability.isGeographyFlagProduct" active-value="Y"
                                               inactive-value="N" active-color="#13ce66"
                                               inactive-color="#ff4949"></el-switch>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">发证机关</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.licenceIssuingAuthority"
                                              placeholder="请填写发证机关"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">地理标志证书编号</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.geographyCertificateNo"
                                              placeholder="请填写地理标志证书编号"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">核准登记产品全称</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.geographyProductName"
                                              placeholder="请填写核准登记产品全称"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">登记申请人名称</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.geographyApplyName"
                                              placeholder="请填写登记申请人名称"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">产品生产总规模</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.productTotalProductionScale"
                                              placeholder="请填写产品生产总规模"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">质量控制规范编号</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.qualityControlNumber"
                                              placeholder="请填写质量控制规范编号"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="value">
                                    <div class="key">登记时间</div>
                                    <div class="value">
                                        <el-date-picker
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                v-model="skuInfo.registrationTime"
                                                type="date"
                                                placeholder="请填写登记时间">
                                        </el-date-picker>
                                    </div>
                                </div>
                            </div>

                            <div class="line">
                                <div class="key">登记证书</div>
                                <div class="value">
                                    <el-upload
                                            ref="TraceabilityRegistrationCertificate"
                                            class="upload-demo"
                                            multiple
                                            name="multipartFile"
                                            :on-remove="removeTraceabilityFiles"
                                            :before-remove="beforeRemoveTraceabilityFiles"
                                            :on-exceed="traceabilityFilesExceed"
                                            :on-success="traceabilityFilesSuccess"
                                            :data="uploadParam.TraceabilityRegistrationCertificate"
                                            :action="baseURL+'/system/uploadFiles'"
                                            :limit="10"
                                            list-type="picture-card"
                                            :file-list="traceabilityRegistrationCertificateFiles"
                                            accept=".jpg,.png">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">
                                            地理标志登记证书图片，尺寸为750（宽度）：不限（高度），文件格式为通用jpg/png，数量：1 以上
                                        </div>
                                    </el-upload>
                                </div>
                            </div>

                            <div class="line">
                                <div class="key" style="font-weight:bold;">特色文化名片</div>
                            </div>
                            <div class="line">
                                <div class="key">地域位置</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.geographicalLocation"
                                              placeholder="请填写地域位置"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">人文景观</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.placeCulturalInterest"
                                              placeholder="请填写地域位置"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">美食特产</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.foodSpecialties"
                                              placeholder="请填写地域位置"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">非遗文化</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.intangibleCulturalHeritage"
                                              placeholder="请填写非遗文化"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">数字名片</div>
                                <div class="value">
                                    <el-upload
                                            ref="TraceabilityDigitalBusinessCard"
                                            class="upload-demo"
                                            multiple
                                            name="multipartFile"
                                            :on-remove="removeTraceabilityFiles"
                                            :before-remove="beforeRemoveTraceabilityFiles"
                                            :on-exceed="traceabilityFilesExceed"
                                            :on-success="traceabilityFilesSuccess"
                                            :data="uploadParam.TraceabilityDigitalBusinessCard"
                                            list-type="picture-card"
                                            :action="baseURL+'/system/uploadFiles'"
                                            :limit="10"
                                            :file-list="traceabilityDigitalBusinessCardFiles"
                                            accept=".jpg,.png">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">数字名片图片，尺寸为750（宽度）：不限（高度），文件格式为通用jpg/png，数量：1 以上</div>
                                    </el-upload>
                                </div>
                            </div>

                            <div class="line">
                                <div class="key" style="font-weight:bold;">生产者感言</div>
                            </div>
                            <div class="line">
                                <div class="key">生产者名称</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.producerName"
                                              placeholder="请填写生产者名称"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">发表感言</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.giveSpeech"
                                              placeholder="请填写发表感言"></el-input>
                                </div>
                            </div>
                            <div class="line">
                                <div class="key">现场实拍</div>
                                <div class="value">
                                    <el-upload
                                            ref="TraceabilityLiveFilming"
                                            class="upload-demo"
                                            multiple
                                            name="multipartFile"
                                            :on-remove="removeTraceabilityFiles"
                                            :before-remove="beforeRemoveTraceabilityFiles"
                                            :on-exceed="traceabilityFilesExceed"
                                            :on-success="traceabilityFilesSuccess"
                                            :data="uploadParam.TraceabilityLiveFilming"
                                            :action="baseURL+'/system/uploadFiles'"
                                            :limit="10"
                                            list-type="picture-card"
                                            :file-list="traceabilityLiveFilmingFiles"
                                            accept=".jpg,.png">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">数字名片图片，尺寸为750（宽度）：不限（高度），文件格式为通用jpg/png，数量：1 以上</div>
                                    </el-upload>
                                </div>
                            </div>

                            <div class="line">
                                <div class="key" style="font-weight:bold;">防伪码标签</div>
                            </div>
                            <div class="line">
                                <div class="key">追溯辨识码</div>
                                <div class="value">
                                    <el-input class="w500" v-model="traceability.traceabilityIdentificationCode"
                                              placeholder="请填写SN11位追溯辨识码"></el-input>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="backSteps">上一步</el-button>
                    <el-button @click="nextSteps">下一步</el-button>
                    <el-button @click="showTraceability = false">取 消</el-button>
                    <el-button type="primary" @click="updateTraceability">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog title="溯源码列表" :visible.sync="showTraceabilitys" width="70%">
                <div style="margin-bottom: 40px;margin-top: 20px;">
                    <div class="dataShow">
                        <el-table :data="skuInfo.traceabilitys" style="width: 100%" height="250">
                            <el-table-column fixed  label="序号" width="150">
                                <template slot-scope="scope"> {{scope.$index+1}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="traceabilityIdentificationCode" label="追溯辨识码" width="300"></el-table-column>
                            <el-table-column  label="溯源码"  width="220">
                                <template slot-scope="scope">
                                    <el-image style="width: 70px;height: 70px;"  :src="scope.row.dimensionalBarcode"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createTime" label="溯源时间" width="200"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="220">
                                <template slot-scope="scope">
                                    <el-button @click="editTraceability(scope.row)" type="text" size="small">编辑</el-button>
                                    <el-button @click="queryTraceabilityRecord(scope.row.id,1)" type="text" size="small">扫码记录</el-button>
                                    <el-button @click="downloadTraceability(scope.row)" type="text" size="small">下载二维码</el-button>
                                    <el-button @click="downloadPrintTraceability(scope.row)" type="text" size="small">下载打印二维码</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showTraceabilitys = false">取 消</el-button>
                    <el-button type="primary" @click="showTraceabilitys = false">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog title="下载" :visible.sync="isDownload" width="30%">
                <div style="margin-bottom: 40px;margin-top: 20px;">
                    <div style="justify-content: center;display: flex;">
                        <div ref="postHtml" style="width:450px;height: 300px;display: flex">
                            <div style="display: grid;justify-content: center;width:450px;height: 300px;">
                                <div style="display: flex;">
                                    <div style="display: grid;align-items: center;">
                                        <div style="display: grid;">
                                            <div style="font-weight: 700;font-family: PingFangSC,KaiTi,serif;color: rgba(0, 0, 0, 1);font-size: 40px;">全程追溯</div>
                                            <div style="font-weight: 700;font-family: PingFangSC,KaiTi,serif;color: rgba(0, 0, 0, 1);font-size: 40px;">放心购买</div>
                                        </div>
                                        <div style="display: flex;justify-content: end;align-items: center;padding-left: 25px;margin-top: -20px;">
                                            <img style="width: 30px;height: 30px;" src="../../assets/img/suyuan.png">
                                            <div style="margin-left: 5px;margin-right: 5px;font-size: 20px;font-weight: 500;">溯源码</div>
                                            <div style="width: 0px;height: 0px;border: 10px solid;border-left-color: black;border-right-color: transparent;border-top-color: transparent; border-bottom-color: transparent;"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <img style="width: 250px;height: 250px;" :src="qrCodeImgBase64Str">
                                    </div>
                                </div>
                                <div style="font-size: 25px;letter-spacing: 1px;font-family: PingFangSC,KaiTi,serif;colorrgba(102, 102, 102, 1);letter-spacing: 2px;font-weight: 600;opacity: 1;text-align: center;">追溯辨识码：SN12820231102</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeDownloadSuYuan()">取 消</el-button>
                    <el-button type="primary" @click="downloadSuYuan()">确认下载</el-button>
                </div>
            </el-dialog>
            <el-dialog title="扫码记录" :visible.sync="showTraceabilityRecord" width="50%">
                <div style="margin-bottom: 40px;margin-top: 20px;">
                    <div class="dataShow">
                        <el-table :data="traceabilityRecord" style="width: 100%" height="300">
                            <el-table-column fixed  label="序号" width="150">
                                <template slot-scope="scope"> {{scope.$index+1}}</template>
                            </el-table-column>
                            <el-table-column prop="deviceName" label="用户设备" width="200"></el-table-column>
                            <el-table-column prop="ipAddress" label="用户IP" width="200"></el-table-column>
                            <el-table-column prop="createTime" label="扫码时间" width="200"></el-table-column>
                        </el-table>
                        <el-button @click="queryTraceabilityRecord(traceabilityId,++traceabilityNum)">查看更多</el-button>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showTraceabilityRecord = false">取 消</el-button>
                </div>
            </el-dialog>
            <div class="line">
                <div class="key"></div>
                <div class="value">
                    <i v-show="skuInfo.isImg"></i>
                    <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
                    <el-button v-if="this.skuInfoId" type="success" size="medium" @click="openTraceability">关联溯源码信息</el-button>
                    <el-button v-if="this.skuInfoId" type="success" size="medium" @click="openTraceabilitys">溯源码列表</el-button>
                </div>
            </div>
            <div class="line"></div>
        </div>
        <div class="but">
            <el-button type="danger" size="small" @click="backClick">返回</el-button>
        </div>
    </div>
</template>

<script>
    import {
        newVue, updateSkuInfo, getSkuInfoById, getSkuInfoClassify, SkuClassify, getPmsExtra, Extras, getLabel, LabelValue,
        SkuLabelValue, uploadSkuImgs, PmsDetailImg, getMerchantNames,updateTraceability,queryTraceability,queryTraceabilityRecord
    } from "../../network/skuInfo";
    import {getSysDict} from "../../network/system"
    import {getCoveShedAddressAll, getCoveShedAddressByCity, getCoveShedAll} from "../../network/coveShed";
    import SelectInput from "../../components/common/selectInput/SelectInput";
    import html2canvas from "html2canvas";


    export default {
        name: "skuInfoInsert",
        components: {SelectInput},
        data() {
            return {
                dialogImageUrl: '',
                skuInfo: {
                    isImg: false,
                    labelValues: [],
                    detailImgs: [],
                    pmsExtras: [],
                    postageList: [],
                    graphicalDetails: [],
                    merchants: {}
                },
                skuInfoId: '',
                skuClassify: [],
                activityClassify: [
                    {
                        "value": "普通商品",
                        "label": "普通商品"
                    },
                    {
                        "value": "拼团商品",
                        "label": "拼团商品"
                    },
                    {
                        "value": "秒购商品",
                        "label": "秒购商品"
                    }
                ],
                specialClassify: [
                    {
                        "value": "无",
                        "label": "无"
                    },
                    {
                        "value": "坞栈商品",
                        "label": "坞栈商品"
                    }
                ],
                fertilizerType: [
                    {
                        "value": "OrganicFertilizers",
                        "label": "有机化肥"
                    },
                    {
                        "value": "EnzymeComposting",
                        "label": "酵素堆肥"
                    },
                    {
                        "value": "HumicAcidFertilizer",
                        "label": "腐植酸肥料"
                    },
                    {
                        "value": "SeaweedFertilizer",
                        "label": "海藻肥料"
                    },
                    {
                        "value": "MulticomponentFertilizer",
                        "label": "多种混合肥料"
                    },
                ],
                fertilizationType: [
                    {
                        "value": "ArtificialFertilization",
                        "label": "人工施肥"
                    },
                    {
                        "value": "MechanicalFertilization",
                        "label": "机械施肥"
                    },
                    {
                        "value": "SemiManualFertilization",
                        "label": "半人工施肥"
                    },
                ],
                administerType: [
                    {
                        "value": "Physics",
                        "label": "物理防治干预"
                    },
                    {
                        "value": "Biopharmaceuticals",
                        "label": "喷洒生物药剂"
                    },
                    {
                        "value": "ChemicalAgents",
                        "label": "喷洒化学药剂"
                    },
                ],
                recoveryType: [
                    {
                        "value": "ManualHarvesting",
                        "label": "人工采收"
                    },
                    {
                        "value": "MechanicalHarvesting",
                        "label": "机械采收"
                    },
                    {
                        "value": "SemiManualHarvesting",
                        "label": "半人工采收"
                    },
                ],
                processingType: [
                    {
                        "value": "Artificial",
                        "label": "人工"
                    },
                    {
                        "value": "Machinery",
                        "label": "机械"
                    },
                    {
                        "value": "SemiManual",
                        "label": "半人工"
                    },
                ],
                //前端商品服务展示
                pmsExtras: [],
                //前端标签展示
                labels: [],
                //输入框信息展示
                label: "",
                //前台显示的商品详情图数据--头部轮播
                fileList: [],
                //农基商集合展示
                merchantNames: [],
                authorization: "",
                headers: {},
                fileData: {},
                graphicalDetailsFileData: {},
                //loading实例
                loading: {},
                baseURL: newVue.baseURL,
                isImgActiveArr: [],
                graphicalDetailsArr: [],
                //坞栈商品市区地址合集
                cityArr: [],
                //坞栈商品名称合集
                coveShedNames: [],
                //心坞栈社区集合
                cityArrTwo: [],
                secondaryTypes: [],
                dialogFormVisible: false,//是否展示绑定引荐人
                showDivideCommissionInformation: false,
                showTraceability: false,//溯源码表单
                showTraceabilitys: false,//溯源码列表
                stepIndex: 1,//步骤Index
                traceability: {},//溯源码信息
                uploadParam: {
                    TraceabilityBusinessLicense: {type: "TraceabilityBusinessLicense"},
                    TraceabilityQualityInspectionReport: {type: "TraceabilityQualityInspectionReport"},
                    TraceabilityRegistrationCertificate: {type: "TraceabilityRegistrationCertificate"},
                    TraceabilityDigitalBusinessCard: {type: "TraceabilityDigitalBusinessCard"},
                    TraceabilityLiveFilming: {type: "TraceabilityLiveFilming"},
                    SkuInfoGraphicalDetails:{type:"SkuInfoGraphicalDetails"},
                    TraceabilitySugarMeasurementVoucher:{type:"TraceabilitySugarMeasurementVoucher"}
                },
                traceabilityBusinessLicenseFiles: [],//溯源码营业执照
                traceabilityQualityInspectionReportFiles: [],//溯源码质检报告
                traceabilityRegistrationCertificateFiles: [],//溯源码登记证书
                traceabilityDigitalBusinessCardFiles: [],//溯源码数字名片
                traceabilityLiveFilmingFiles: [],//现场实拍
                skuInfoGraphicalDetailsFiles: [],//图示详情
                traceabilitySugarMeasurementVoucherFiles: [],//图示详情
                sweetnessRange:[0,100],//甜度范围
                traceabilityRecord:[],
                showTraceabilityRecord:false,//展示溯源码扫码记录
                traceabilityId:"",
                traceabilityNum:1,
                isDownload:false,
                qrCodeImgBase64Str:"",//需要下载的溯源码对应的Base64
                traceabilityCode:""//溯源码Code
            }
        },
        computed: {
            limit() {
                return 10 - this.skuInfo.detailImgs.length;
            }
        },
        created() {
            newVue.obj = this;
            this.authorization = newVue.obj.common.loginInfo.jwtToken;
            this.headers.Authorization = this.authorization;
            this.common.HeaderLocationTwo.href = "/pmsSkuInfo/list";
            this.common.HeaderLocationTwo.name = "农商品管理";
            this.common.HeaderLocationThree.name = "新增or修改农商品"
            getSkuInfoClassify().then(res => {
                for (let i = 0; i < res.data.length; i++) {
                    this.skuClassify.push(new SkuClassify(res.data[i].id, res.data[i].classifyName))
                }
            });
            getPmsExtra().then(res => {
                for (let i = 0; i < res.data.length; i++) {
                    this.pmsExtras.push(new Extras(res.data[i].id, res.data[i].extraService))
                }
            });
            getSysDict("ProductSecondaryType").then(res => {//获取商品二级字典
                if (res.data != null) {
                    this.secondaryTypes = [];
                    for (let i = 0; i < res.data.length; i++) {
                        this.secondaryTypes.push({value: res.data[i].value, label: res.data[i].name});
                    }
                }
            });
            if (this.$route.params.id != null) {
                this.skuInfoId = this.$route.params.id;
                getSkuInfoById(this.skuInfoId).then(res => {
                    this.skuInfo = res.data;
                    let isImgActiveArr = []
                    for (let i = 0; i < this.skuInfo.detailImgs.length; i++) {
                        isImgActiveArr.push(false);
                    }
                    this.isImgActiveArr = isImgActiveArr;
                    this.skuInfoGraphicalDetailsFiles = this.skuInfo.graphicalDetails;
                    if (this.skuInfo.isDivideCommission == 'Y'){
                        this.showDivideCommissionInformation = true;
                    }
                    this.profitCount();
                })
            }
        },
        methods: {
            getCoveShedName() {
                if (this.coveShedNames.length <= 0) {
                    //根据心坞栈区域/社区来获取心坞栈名称
                    getCoveShedAll(this.skuInfo.coveShedCity, this.skuInfo.coveShedCityTwo).then(res => {
                        let i = 0;
                        res.data.forEach(e => {
                            let cityItem = {}
                            cityItem.id = i
                            cityItem.value = e.coveShedName
                            this.coveShedNames.push(cityItem)
                            i++
                        })
                    })
                }
            },
            getCoveShedCityTwo() {
                if (this.cityArrTwo.length <= 0) {
                    // 根据心坞栈区域来获取心坞栈社区列表
                    getCoveShedAddressByCity(this.skuInfo.coveShedCity).then(res => {
                        let i = 0;
                        res.data.forEach(e => {
                            let cityItem = {}
                            cityItem.id = e.id
                            cityItem.value = e.labelTwoName
                            this.cityArrTwo.push(cityItem)
                            i++
                        })
                    })
                }
            },
            handleSelectCoveShedName(item) {
                this.$set(this.skuInfo, "coveShedName", item.value);
            },
            handleSelectCoveShedCityTwo(item) {
                this.$set(this.skuInfo, "coveShedCityTwo", item.value);
                this.coveShedNames = []
                this.$set(this.skuInfo, "coveShedName", "");
            },
            getCoveShedCity() {
                if (this.cityArr.length <= 0) {
                    // 获取心坞栈区域(市/区)列表
                    getCoveShedAddressAll().then(res => {
                        let i = 0;
                        res.data.forEach(e => {
                            let cityItem = {}
                            cityItem.id = i
                            cityItem.value = e
                            this.cityArr.push(cityItem)
                            i++
                        })
                    })
                }
            },
            handleSelectMerchants(item) {
                this.$set(this.skuInfo, "merchantsName", item.value);
            },
            getMerchantNameArr() {
                if (this.merchantNames.length <= 0) {
                    getMerchantNames().then(res => {
                        for (let i = 0; i < res.data.length; i++) {
                            let merchantsItem = {}
                            merchantsItem.value = res.data[i]
                            this.merchantNames.push(merchantsItem)
                        }
                    })
                }

            },
            getLabelValues() {
                if (this.labels.length <= 0 && this.skuInfo.labelValues.length <= 0) {
                    getLabel().then(res => {
                        for (let i = 0; i < res.data.length; i++) {
                            this.labels.splice(res.data[i].id, 0, new LabelValue(res.data[i].id, res.data[i].labelName))
                        }
                    });
                }

            },
            handleSelectCoveShedCity(item) {
                this.$set(this.skuInfo, "coveShedCity", item.value);
                this.coveShedNames = []
                this.coveShedTwoCity = []
                this.$set(this.skuInfo, "coveShedCityTwo", "");
                this.$set(this.skuInfo, "coveShedName", "");
            },
            delDetailImgs(index) {
                this.$confirm('正在删除图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.skuInfo.detailImgs.splice(index, 1)
                    this.isImgActiveArr.splice(index, 1)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            detailImgs_mouseout(index) {
                this.$set(this.isImgActiveArr, index, false);
            },
            detailImgs_mouseover(index) {
                this.$set(this.isImgActiveArr, index, true);
            },
            graphicalDetails_mouseout(index) {
                this.$set(this.graphicalDetailsArr, index, false);
            },
            graphicalDetails_mouseover(index) {
                this.$set(this.graphicalDetailsArr, index, true);
            },
            addPostage() {
                let postage = {}
                this.skuInfo.postageList.push(postage)
            },
            defaultSuccess(response, file, fileList) {
                this.loading.close()
                this.skuInfo.skuDefaultImgUrl = response.data
                this.skuInfo.isImg = !this.skuInfo.isImg
            },
            swiperSuccess(response, file, fileList) {
                this.loading.close()
                this.skuInfo.swiperImg = response.data
                this.skuInfo.isImg = !this.skuInfo.isImg
            },
            //移除
            handleRemove(file, fileList) {
                this.fileList = fileList;
                // return this.$confirm(`确定移除 ${ file.name }？`);
            },
            // 选取文件超过数量提示
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 ${10 - this.skuInfo.detailImgs.length} 个文件，本次选择了 ${files.length} 个文件`);
            },
            handleExceedgraphicalDetails(files, fileList) {
                this.$message.warning(`当前限制选择 ${10 - this.skuInfo.graphicalDetails.length} 个文件，本次选择了 ${files.length} 个文件`);
            },
            //监控上传文件列表
            fileChange(file, fileList) {
                let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
                if (existFile) {
                    this.$message.error('当前文件已经存在!');
                    fileList.pop();
                }
                this.fileList = fileList;
            },
            handleSelectLabel(item) {
                this.label = "";
                let skuLabelValue = new SkuLabelValue(item)
                this.skuInfo.labelValues.push(skuLabelValue)
                let a = item.id < this.labels.length - 1 ? item.id : this.labels.length - 1;
                for (a; a >= 0; a--) {
                    if (this.labels[a].id === item.id) {
                        this.labels.splice(a, 1)
                    }
                }
            },
            handleChange(value) {
            },
            backClick() {
                this.$router.push("../list");
            },
            defaultUpload(file, fileList) {
                if (file.name.indexOf("png") || file.name.indexOf("jp")) {
                    this.$refs.defaultUpload.submit()
                } else {
                    this.$message({
                        showClose: true,
                        message: '请上传jpg或png等图片',
                        type: 'error'
                    })
                }
            },
            swiperUpload(file, fileList) {
                if (file.name.indexOf("png") || file.name.indexOf("jp")) {
                    this.$refs.swiperUpload.submit()
                } else {
                    this.$message({
                        showClose: true,
                        message: '请上传jpg或png等图片',
                        type: 'error'
                    })
                }
            },
            submit() {
                let postageList = this.skuInfo.postageList
                if (postageList != null && postageList.length > 0) {
                    while (postageList[postageList.length - 1].postageKey == null && postageList[postageList.length - 1].postageValue == null && postageList[postageList.length - 1].postagePrice == null) {
                        postageList.pop();
                    }
                }
                this.skuInfo.postageList = postageList;
                this.skuInfo.graphicalDetails = this.skuInfoGraphicalDetailsFiles;
                updateSkuInfo(this.skuInfo).then(res => {
                })
            },
            delLabel(index) {
                this.skuInfo.labelValues.splice(index, 1);
            },
            // 上传文件
            uploadFile(file) {
                this.fileData.append("multipartFiles", file.file);  // append增加数据
            },
            // 上传到服务器
            submitUpload() {
                if (this.fileList.length === 0) {
                    this.$message({
                        message: '请先选择文件',
                        type: 'warning'
                    })
                } else {
                    this.loading = this.$loading({
                        lock: true,
                        text: '正在上传中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.fileData = new FormData();  // new formData对象
                    this.$refs.upload.submit();  // 提交调用uploadFile函数
                    // this.fileData.append('loginToken', this.loginToken);  // 添加token
                    uploadSkuImgs(this.fileData).then((res) => {
                        if (res.code == 200) {
                            this.loading.close()
                            for (let i = 0; i < res.data.length; i++) {
                                this.skuInfo.detailImgs.push(new PmsDetailImg(null, this.skuInfo.id, res.data[i]))
                            }
                            let isImgActiveArr = []
                            for (let i = 0; i < this.skuInfo.detailImgs.length; i++) {
                                isImgActiveArr.push(false)
                            }
                            this.isImgActiveArr = isImgActiveArr
                            this.$message({
                                message: "上传成功",
                                type: 'success'
                            });
                            this.fileList = [];
                        } else {
                            this.$message({
                                message: res.message,
                                type: 'error'
                            })
                        }
                    });
                }
            },
            progress() {
                this.loading = this.$loading({
                    lock: true,
                    text: '正在上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },
            changeDivideCommission(value) {//改变 参与分佣
                if (this.skuInfo.isDivideCommission == 'Y') {
                    this.showDivideCommissionInformation = true;
                } else {
                    this.showDivideCommissionInformation = false;
                }
            },
            profitCount() {
                //利润计算
                //共计成本=商品成本价+运营成本+其他成本
                //商品利润=售价-成本价
                //利润比例=（售价-成本价）/成本价
                if (this.skuInfo.skuPrice != null && this.skuInfo.materialCost != null && this.skuInfo.operateCost && this.skuInfo.packagingMaterialsCost) {
                    this.skuInfo.totalCost = 0;
                    this.skuInfo.commodityProfit = 0;
                    this.skuInfo.profitRatio = 0;
                    this.skuInfo.totalCost = this.skuInfo.materialCost + this.skuInfo.operateCost + this.skuInfo.packagingMaterialsCost;
                    if (this.skuInfo.otherCost != null) {
                        this.skuInfo.totalCost += this.skuInfo.otherCost;
                    }
                    if (this.skuInfo.skuPrice - this.skuInfo.totalCost <= 0) {
                        this.skuInfo.totalCost = 0;
                        this.$message({
                            message: '商品售价小于成本价,请确认是否正确',
                            type: 'warning'
                        })
                        return;
                    }
                    this.skuInfo.commodityProfit = parseInt(this.skuInfo.skuPrice) - this.skuInfo.totalCost;
                    this.skuInfo.profitRatio = ((this.skuInfo.commodityProfit / this.skuInfo.skuPrice) * 100).toFixed(2) + "%";
                }
            },
            upLoadTraceability() {

            },
            handleTraceabilitySuccess() {

            },
            previewTraceabilityFile() {
            },
            removeTraceabilityFile() {
            },
            openTraceability() {
                this.showTraceability = true;
            },
            openTraceabilitys() {
                this.showTraceabilitys = true;
            },
            traceabilityFilesExceed() {
                this.$message.warning(`当前限制选择 10 个文件;`);
            },
            beforeRemoveTraceabilityFiles(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            removeTraceabilityFiles(file, fileList) {
                var arr = [];
                switch (file.associationType) {
                    case "TraceabilityBusinessLicense":
                        for (let i = 0; i < this.traceabilityBusinessLicenseFiles.length; i++) {
                            if (file.id != this.traceabilityBusinessLicenseFiles[i].id) {
                                arr.push(this.traceabilityBusinessLicenseFiles[i]);
                            }
                        }
                        this.traceabilityBusinessLicenseFiles = arr;
                        break;
                    case "TraceabilityQualityInspectionReport":
                        for (let i = 0; i < this.traceabilityQualityInspectionReportFiles.length; i++) {
                            if (file.id != this.traceabilityQualityInspectionReportFiles[i].id) {
                                arr.push(this.traceabilityQualityInspectionReportFiles[i]);
                            }
                        }
                        this.traceabilityQualityInspectionReportFiles = arr;
                        break;
                    case "TraceabilityRegistrationCertificate":
                        for (let i = 0; i < this.traceabilityRegistrationCertificateFiles.length; i++) {
                            if (file.id != this.traceabilityRegistrationCertificateFiles[i].id) {
                                arr.push(this.traceabilityRegistrationCertificateFiles[i]);
                            }
                        }
                        this.traceabilityRegistrationCertificateFiles = arr;
                        break;
                    case "TraceabilityDigitalBusinessCard":
                        for (let i = 0; i < this.traceabilityDigitalBusinessCardFiles.length; i++) {
                            if (file.id != this.traceabilityDigitalBusinessCardFiles[i].id) {
                                arr.push(this.traceabilityDigitalBusinessCardFiles[i]);
                            }
                        }
                        this.traceabilityDigitalBusinessCardFiles = arr;
                        break;
                    case "TraceabilityLiveFilming":
                        for (let i = 0; i < this.traceabilityLiveFilmingFiles.length; i++) {
                            if (file.id != this.traceabilityLiveFilmingFiles[i].id) {
                                arr.push(this.traceabilityLiveFilmingFiles[i]);
                            }
                        }
                        this.traceabilityLiveFilmingFiles = arr;
                        break;
                    case "SkuInfoGraphicalDetails":
                        for (let i = 0; i < this.skuInfoGraphicalDetailsFiles.length; i++) {
                            if (file.id != this.skuInfoGraphicalDetailsFiles[i].id) {
                                arr.push(this.skuInfoGraphicalDetailsFiles[i]);
                            }
                        }
                        this.skuInfoGraphicalDetailsFiles = arr;
                        break;
                    case "TraceabilitySugarMeasurementVoucher":
                        for (let i = 0; i < this.traceabilitySugarMeasurementVoucherFiles.length; i++) {
                            if (file.id != this.traceabilitySugarMeasurementVoucherFiles[i].id) {
                                arr.push(this.traceabilitySugarMeasurementVoucherFiles[i]);
                            }
                        }
                        this.traceabilitySugarMeasurementVoucherFiles = arr;
                        break;
                }
            },
            traceabilityFilesSuccess(res, file) {
                let item = {};
                item["name"] = file.name;
                item["id"] = file.uid;
                item["fileSize"] = file.raw.size;
                item["fileType"] = file.raw.type;
                item["associationType"] = res.data[0].associationType;
                item["url"] = res.data[0].url;
                item["imageUrl"] = URL.createObjectURL(file.raw);debugger
                if (file.response != null) {
                    switch (res.data[0].associationType) {
                        case "TraceabilityBusinessLicense":
                            this.traceabilityBusinessLicenseFiles.push(item);
                            break;
                        case "TraceabilityQualityInspectionReport":
                            this.traceabilityQualityInspectionReportFiles.push(item);
                            break;
                        case "TraceabilityRegistrationCertificate":
                            this.traceabilityRegistrationCertificateFiles.push(item);
                            break;
                        case "TraceabilityDigitalBusinessCard":
                            this.traceabilityDigitalBusinessCardFiles.push(item);
                            break;
                        case "TraceabilityLiveFilming":
                            this.traceabilityLiveFilmingFiles.push(item);
                            break;
                        case "SkuInfoGraphicalDetails":
                            this.skuInfoGraphicalDetailsFiles.push(item);
                            break;
                        case "TraceabilitySugarMeasurementVoucher":
                            this.traceabilitySugarMeasurementVoucherFiles.push(item);
                            break;
                    }
                }
                if (this.loadingMsg != null) {
                    this.loadingMsg.close();
                }
                this.$forceUpdate();
            },
            updateTraceability(){debugger
                this.traceability.businessLicense = this.traceabilityBusinessLicenseFiles;
                this.traceability.qualityInspectionReport = this.traceabilityQualityInspectionReportFiles;
                this.traceability.registrationCertificate = this.traceabilityRegistrationCertificateFiles;
                this.traceability.digitalBusinessCard = this.traceabilityDigitalBusinessCardFiles;
                this.traceability.liveFilming = this.traceabilityLiveFilmingFiles;
                this.traceability.sugarMeasurementVoucher = this.traceabilitySugarMeasurementVoucherFiles;
                this.traceability.skuId = this.skuInfoId;
                this.showTraceability = false;
                if (this.sweetnessRange.length == 2){
                    this.traceability.sweetnessMin = this.sweetnessRange[0] + "";
                    this.traceability.sweetnessMax = this.sweetnessRange[1] + "";
                }
                updateTraceability(this.traceability).then(res => {});

            },
            editTraceability(traceability){
                queryTraceability((traceability.id+""),"N").then(res => {
                    this.traceability = res.data;
                    this.traceabilityBusinessLicenseFiles = res.data.businessLicense;
                    this.traceabilityQualityInspectionReportFiles = res.data.qualityInspectionReport;
                    this.traceabilityRegistrationCertificateFiles = res.data.registrationCertificate;
                    this.traceabilityDigitalBusinessCardFiles = res.data.digitalBusinessCard;
                    this.traceabilityLiveFilmingFiles = res.data.liveFilming;
                    this.traceabilitySugarMeasurementVoucherFiles = res.data.sugarMeasurementVoucher;
                    this.showTraceability = true;
                    this.showTraceabilitys = false;
                    if (res.data.sweetnessMin && res.data.sweetnessMax)
                    this.sweetnessRange[0] = parseInt(res.data.sweetnessMin);
                    this.sweetnessRange[1] = parseInt(res.data.sweetnessMax);
                    this.$forceUpdate();
                })

            },
            backSteps(){
                this.stepIndex = this.stepIndex - 1;
                if (this.stepIndex < 1){this.stepIndex = 1;}
            },
            nextSteps(){
                this.stepIndex = this.stepIndex + 1;
                if (this.stepIndex > 3){this.stepIndex = 3;}
            },
            queryTraceabilityRecord(id,num){
                queryTraceabilityRecord(id,num).then(res => {
                     if (res.data){
                         if (this.traceabilityId!=id){
                             this.traceabilityRecord = [];
                         }
                         this.traceabilityId = id;
                         for (let i = 0; i < res.data.list.length; i++) {
                             this.traceabilityRecord.push(res.data.list[i]);
                         }
                         this.showTraceabilityRecord = true;
                         this.showTraceabilitys = false;
                     }
                });
            },
            downloadTraceability(traceability){//下载二维码
                const url = traceability.dimensionalBarcode;
                // 下载文件的url
                const link = document.createElement('a');
                link.href = url;
                link.download = url;
                // 下载文件的名称
                link.click();
            },
            downloadPrintTraceability(traceability){
                this.qrCodeImgBase64Str = traceability.dimensionalBarcodeBase64;
                this.traceabilityCode = traceability.traceabilityIdentificationCode;
                this.isDownload = true;
            },
            closeDownloadSuYuan(){
                this.qrCodeImgBase64Str = "";
                this.isDownload = false;
            },
            downloadSuYuan(){
                const name = "溯源二维码";
                const posterHtml = this.$refs.postHtml;
                // 生成海报
                const domObj = posterHtml;
                html2canvas(domObj, {
                    scale:10,
                    dpi: 800,
                    allowTaint: true,
                    useCORS: true,
                    width: 450,
                    height: 300,
                    // scrollY: -18,
                    // scrollX: -0,
                    onclone(doc) {}
                }).then(canvas => {
                    this.downloadQRImg(canvas, name);
                });
            },
            downloadQRImg(canvas, name) {
                /** 新Image对象，可以理解为DOM */
                let image = new Image();
                /** 解决跨域 Canvas 污染问题 */
                image.setAttribute("crossOrigin", "anonymous");
                // image.onload = function() {
                /** canvas.toDataURL 返回的是一串Base64编码的URL,指定格式 PNG */

                // 【重要】关闭抗锯齿
                canvas.mozImageSmoothingEnabled = false
                canvas.webkitImageSmoothingEnabled = false
                canvas.msImageSmoothingEnabled = false
                canvas.imageSmoothingEnabled = false

                let imgUrl = canvas.toDataURL("image/png");
                image.src = imgUrl;
                /** 生成一个a元素,并创建一个单击事件 */
                let a = document.createElement("a");
                a.download = name || "photo"; // 设置图片名称
                a.href = imgUrl; // 将生成的URL设置为a.href属性
                a.setAttribute("id", "myLink");
                document.body.appendChild(a);
                this.exportCodeConfirm();
                this.qrCodeImgBase64Str = "";
                this.isDownload = false;
            },
            exportCodeConfirm() {
                setTimeout(() => {
                    let event = new MouseEvent("click");
                    /** 触发a的单击事件 */
                    document.getElementById("myLink").dispatchEvent(event);
                }, 0);
            },
            limitationCommission(){
                if (this.skuInfo.recommendCommissionProportion>5){
                    this.skuInfo.recommendCommissionProportion = null;
                }
                if (this.skuInfo.recommendCommissionProportion<1){
                    this.skuInfo.recommendCommissionProportion = null;
                }
            },
        }

    }
</script>

<style scoped>
    @import "../../assets/css/data.css";

    .w500 {
        width: 500px;
    }

    .tag {
        display: inline-block;
        height: 30px;
        background-color: #67c23a;
        border-color: #e9e9eb;
        color: white;
        box-sizing: border-box;
        margin: 2px 6px 2px 0;
        padding: 0 8px;
        line-height: 30px;
    }

    .tag span {
        margin-right: 3px;
    }

    .tag i {

    }

    .skuImg {
        width: 150px;
        height: 150px;
    }

    .skuImgDiv {
        width: 150px;
        height: 150px;
        margin-right: 30px;
        position: relative;
        display: inline-block;
    }

    .deleteIcon {
        position: absolute;
        top: 65px;
        left: 65px;
        z-index: 5;
        width: 20px;
        height: 20px;
    }

    .swiperImg {
        width: 370px;
        height: 148px;
        display: inline-block;
        vertical-align: top;
        margin-right: 30px;
    }

    .upload {
        display: inline-block;
    }

    .postageList {
        display: flex;
    }
    .sanjiao{
        width: 0px;
        height: 0px;
        /* border是240px则三角形底边长为480px  */
        border: 5px solid;
        border-left-color: black;
        border-right-color: transparent;
        border-top-color:  transparent;
        border-bottom-color: transparent;
    }
</style>
